import { tKey } from 'ember-intl';

export const SMART_INSIGHTS_TABS = {
  ACTIVE: 'active',
  ARCHIVED: 'archived',
} as const;
export type SmartInsightsTab =
  (typeof SMART_INSIGHTS_TABS)[keyof typeof SMART_INSIGHTS_TABS];

export const isSmartInsightsTab = (value: string): value is SmartInsightsTab =>
  Object.values(SMART_INSIGHTS_TABS).includes(value as SmartInsightsTab);

export const SMART_INSIGHTS_ARCHIVE_REASONS = {
  ACTION_TAKEN: 'action_taken',
  NOT_ACTIONABLE: 'not_actionable',
} as const;
export type SmartInsightsArchiveReason =
  (typeof SMART_INSIGHTS_ARCHIVE_REASONS)[keyof typeof SMART_INSIGHTS_ARCHIVE_REASONS];

export const SMART_INSIGHTS_ARCHIVE_REASON_TRANSLATIONS: Record<
  SmartInsightsArchiveReason,
  string
> = {
  [SMART_INSIGHTS_ARCHIVE_REASONS.ACTION_TAKEN]: tKey(
    'smart_insights.archive.action_taken',
  ),
  [SMART_INSIGHTS_ARCHIVE_REASONS.NOT_ACTIONABLE]: tKey(
    'smart_insights.archive.not_actionable',
  ),
};

export const SMART_INSIGHTS_VIEWS = {
  CALENDAR: 'calendar',
  LIST: 'list',
} as const;
export type SmartInsightsView =
  (typeof SMART_INSIGHTS_VIEWS)[keyof typeof SMART_INSIGHTS_VIEWS];

export const isSmartInsightsView = (
  value: string,
): value is SmartInsightsView => {
  return Object.values(SMART_INSIGHTS_VIEWS).includes(
    value as SmartInsightsView,
  );
};

export const SMART_INSIGHTS_LIST_SORT_OPTIONS = {
  PRIORITY: 'priority',
  DATE: 'date',
} as const;
export type SmartInsightsListSortOption =
  (typeof SMART_INSIGHTS_LIST_SORT_OPTIONS)[keyof typeof SMART_INSIGHTS_LIST_SORT_OPTIONS];

export const SMART_INSIGHTS_LIST_SORT_OPTIONS_TRANSLATIONS = {
  [SMART_INSIGHTS_LIST_SORT_OPTIONS.PRIORITY]: tKey(
    'smart_insights.list.dropdown_sort.priority',
  ),
  [SMART_INSIGHTS_LIST_SORT_OPTIONS.DATE]: tKey(
    'smart_insights.list.dropdown_sort.date',
  ),
};

export const SMART_INSIGHTS_KPI_COMPARISON_PERIODS = {
  YESTERDAY: 'yesterday',
  THREE_DAYS_AGO: '3_days_ago',
  SEVEN_DAYS_AGO: '7_days_ago',
} as const;
export type SmartInsightsKpiComparisonPeriod =
  (typeof SMART_INSIGHTS_KPI_COMPARISON_PERIODS)[keyof typeof SMART_INSIGHTS_KPI_COMPARISON_PERIODS];

export const SMART_INSIGHTS_KPI_COMPARISON_PERIOD_TRANSLATIONS: Record<
  SmartInsightsKpiComparisonPeriod,
  ReturnType<typeof tKey>
> = {
  [SMART_INSIGHTS_KPI_COMPARISON_PERIODS.YESTERDAY]: tKey(
    'smart_insights.detail_view.vs_yesterday',
  ),
  [SMART_INSIGHTS_KPI_COMPARISON_PERIODS.THREE_DAYS_AGO]: tKey(
    'smart_insights.detail_view.vs_3_days_ago',
  ),
  [SMART_INSIGHTS_KPI_COMPARISON_PERIODS.SEVEN_DAYS_AGO]: tKey(
    'smart_insights.detail_view.vs_7_days_ago',
  ),
};

export const SMART_INSIGHTS_VIEW_LOCAL_STORAGE_KEY = 'smartInsightsView';

// Intercom product tour: https://app.intercom.com/a/apps/gyngqx5w/outbound/tour/57546189
export const SMART_INSIGHTS_TOUR_ID = '57546189';

export const SMART_INSIGHTS_HELP_ARTICLE =
  'en/articles/13561813-smart-insights-overview';
